// @tCentro/Services/CENBrandDetailsProductFamiliesService.ts
import { get } from "@insite/client-framework/Services/ApiService";

export interface RequestBrandDetailsProductFamiliesApiModel {
    brandid: string;
}

export interface BrandProductFamilyChildProduct {
    productId?: string;
    partNumber?: string;
    productShortDescription?: string;
    productLongDescription?: string;
    productUrl?: string;
}

export interface BrandProductFamily {
    familyName: string;
    familyDescription?: string;
    featuredImagePath?: string;
    parentProductUrl?: string;
    childProducts?: BrandProductFamilyChildProduct[];
}

export interface RequestBrandDetailsProductFamiliesModel {
    productFamilies?: BrandProductFamily[];
}

const baseUrl = "/api/v2/brandproductfamily/getProductFamilies/";

export function RequestBrandDetailsProductFamilies(model: RequestBrandDetailsProductFamiliesApiModel) {
    return get<RequestBrandDetailsProductFamiliesModel>(baseUrl, model as any);
}